"use client";

import { useMemo } from "react";
import { Button } from "@/components/fun-ui/Button";
import { UploadPlugin, UploadPluginRenderProps } from "./plugin-interface";
import { getUploadMessages } from "../locales/messages";
import { cn } from "@/lib/utils";

const messages = getUploadMessages();

const LocalFolderPluginTrigger = ({ config, disabled, folderInputRef }: UploadPluginRenderProps) => {
  const acceptAttr = useMemo(
    () =>
      config.formats
        .map((format) => [format.accept, ...format.extensions])
        .flat()
        .join(","),
    [config.formats]
  );

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // 阻止事件冒泡，避免触发 LocalUploadArea 的点击
    event.stopPropagation();
    event.preventDefault();

    const input = folderInputRef?.current;
    if (disabled || !input) return;
    input.setAttribute("webkitdirectory", "");
    input.setAttribute("accept", acceptAttr);
    input.click();
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleButtonClick}
      disabled={disabled}
      className={cn(
        "cursor-pointer text-primary border-primary hover:bg-primary/5 hover:text-primary min-w-[130px] select-none"
      )}
    >
      {messages.buttons.uploadByFolder}
    </Button>
  );
};

export const localFolderPlugin: UploadPlugin = {
  id: "local-folder",
  name: messages.buttons.uploadByFolder,
  source: "local-folder",
  renderTrigger: (props) => <LocalFolderPluginTrigger {...props} />,
};

